module.exports = __webpack_public_path__ + "static/media/profile-taylor.68f11fd7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/profile-taylor.JPG
// module id = 318
// module chunks = 0